import React from 'react'
import Container from 'components/ui/Container'
import BackButton from 'components/ui/buttons/BackButton'
import ucfirst from 'utils/ucfirst'
import CliniquesSwitcher from 'components/ui/CliniquesSwitcher'
import SelectTreatment from 'components/ui/selects/SelectTreatment'
import SelectPersonType from 'components/ui/selects/SelectPersonType'
import SelectRegion from 'components/ui/selects/SelectRegion'
import { useTranslation } from 'react-i18next'

export default () => {
  const { t } = useTranslation()
  const baseClass = 'tw-col-span-12 tw-text-xl tw-font-thin tw-tracking-wide md:tw-text-3xl'
  return (
    <Container>
      <div className="tw-col-span-12">
        <BackButton step={1} />
      </div>
      <div className={baseClass}>
        {ucfirst(t('my-appointment-for'))}
        {' '}
        <SelectTreatment />
        {t('for')}
        {' '}
        <SelectPersonType />
      </div>
      <div className={`${baseClass} tw-mb-4 tw-flex tw-justify-between`}>
        <div>
          {t('at')}
          {' '}
          <SelectRegion />
        </div>
        <CliniquesSwitcher />
      </div>
    </Container>
  )
}
